import React, { useRef } from 'react'
import './PhotoTile.sass'
import Icon from '../../ui/Icon/Icon'
import { usePopUp } from '../../hooks/usePopUp'
import Img from '../../ui/Img/Img'

function PhotoTile({
  key,
  isAvatar,
  isLayout,
  isTeaser,
  isClip,
  imageUrl,
  publicUrl,
  onDelete,
  setAvatar,
  setTeaserPoster,
  setClipPoster,
}) {
  const butRef = useRef()
  const optDd = useRef()
  const [showPopUp] = usePopUp(butRef, optDd)

  return (
    <div className="PhotoTile">
      <div className="PhotoTile-Markers">
        {isAvatar && (
          <div className="PhotoTile-Marker Avatar">
            <Icon name="star" />
          </div>
        )}
        {isTeaser && <div className="PhotoTile-Marker Teaser">T</div>}
        {isClip && <div className="PhotoTile-Marker Clip">C</div>}
      </div>

      <img src={imageUrl || publicUrl} alt="" className="PhotoTile-Skeleton" />
      <div ref={butRef} className="PhotoTile-Marker EditButton">
        <Icon name="ellipsis-v" />
      </div>
      <a href={imageUrl || publicUrl} data-fancybox="images">
        <div className="PhotoTile-Marker ZoomButton">
          <Icon name="search-plus" />
        </div>
      </a>
      <div
        ref={optDd}
        className="PhotoTile-Options"
        style={{ display: showPopUp ? 'flex' : 'none' }}
      >
        <div className="PhotoTile-OptionsContainer">
          <div className="Option" onClick={setAvatar}>
            <Icon
              name="star"
              className={`Avatar ${isAvatar && 'Avatar_theme_active'}`}
            />
          </div>
          <div
            className={`Option ${isTeaser && 'Teaser_theme_active'}`}
            onClick={setTeaserPoster}
          >
            <span>T</span>
          </div>
          <div
            className={`Option ${isClip && 'Clip_theme_active'}`}
            onClick={setClipPoster}
          >
            <span>C</span>
          </div>
          <div className="Option" onClick={onDelete}>
            <Icon name="trash-alt" helperClass="Delete" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PhotoTile
